var n=function(){return null};export{n as renderNothing};
